import { TypeOptions, toast } from "react-toastify";

export const showToast = (msg: string, type: TypeOptions) => {
  toast(`${msg}`, {
    position: "top-right",
    type: type ?? "default",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
